<div @slideInStagger>
  <div class="row mt-4 slide-in-animation">
    <div class="col-md-12">
      <table class="table table-material box-shadow-hover table-responsive-sm">
        <thead class="thead-normal">
        <tr>
          <th class="text-center">{{"to_generate.column.project"|translate}}</th>
          <th class="text-center">{{"to_generate.column.purchase_order"|translate}}</th>
          <th class="text-center">{{"to_generate.column.period"|translate}}</th>
          <th>{{"to_generate.column.client"|translate}}</th>
          <th class="text-center">{{"to_generate.column.contract"|translate}}</th>
          <th class="text-center">{{"to_generate.column.provider"|translate}}</th>
          <th class="text-center">{{"to_generate.column.quantity"|translate}}</th>
          <th class="text-center">{{"to_generate.column.action"|translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let onCall of listContent; let i = index">
          <td class="text-center">
            {{ onCall.projectName }}
          </td>
          <td class="text-center">
            {{ onCall.purchaseOrderNumber }}
          </td>
          <td class="text-center">
            {{ onCall.period | date: "MMM yyyy" }}
          </td>
          <td>
            {{ onCall.client }}
          </td>
          <td class="text-center">
            {{ 'Invoice.mode.'+onCall.contractMode|translate }}
          </td>
          <td class="text-center">
            {{ onCall.consultant }}
          </td>
          <td class="text-center">
            {{ onCall.quantity }}
          </td>
          <td class="text-center">
            <isp-button
              class="px-1"
              [type]="ButtonTypeEnum.ICON"
              [icon]="faPenToSquare"
              [colour]="IspColoursEnum.primary"
              [tooltip]="(!requestBlocked.includes(onCall.requestId) ? 'to_generate.button_generate':'to_generate.waiting_amendment')|translate"
              [disabled]="requestBlocked.includes(onCall.requestId)"
              (trigger)="!requestBlocked.includes(onCall.requestId) ? generateInvoice(onCall) : null"
              [size]="SizeEnum.xs"
            ></isp-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>
